import { Component } from '@angular/core';

@Component({
  selector: 'mg-content-unavailable',
  templateUrl: './ContentUnavailable.component.html',
  styleUrls: ['./ContentUnavailable.component.scss'],
})
export class ContentUnavailableComponent {}
